import {BehaviorSubject} from 'rxjs';
import {SprintsRepository} from '../persistence/sprints_repository';
import {isAfter, isBefore, isSameWeek, parse} from 'date-fns';

export class SprintSelectionManager {
    public selection = new BehaviorSubject<number[]>([]);

    constructor(private sprintsRepository: SprintsRepository) {
        document.getElementsByTagName('body')[0].addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                this.clear();
            }
        });
    }

    public select(sprintId: number): void {
        if (this.selection.value.some((s) => s === sprintId)) {
            this.selection.next([...this.selection.value.filter((s) => s !== sprintId)]);
        } else {
            this.selection.next([...this.selection.value, sprintId]);
        }
    }

    public clear(): void {
        this.selection.next([]);
    }

    public selectRangeUntil(sprintId: number) {
        if (this.selection.value.length === 0) {
            this.select(sprintId);
            return;
        }
        const lastSelected = this.sprintsRepository.find(this.selection.value[this.selection.value.length - 1]);
        if (lastSelected === null) {
            this.select(sprintId);
            return;
        }

        const newlySelected = this.sprintsRepository.find(sprintId);
        if (newlySelected === null) {
            return;
        }

        if (lastSelected.employee_id !== newlySelected.employee_id) {
            //We can only select a range of sprints for a single employee
            this.select(sprintId);
            return;
        }

        const fromDate = parse(newlySelected.date, 'yyyy-MM-dd 00:00:00', new Date());
        const tillDate = parse(lastSelected.date, 'yyyy-MM-dd 00:00:00', new Date());

        const sprintsForEmployee = this.sprintsRepository.findByEmployeeId(newlySelected.employee_id);
        const toBeSelectedSprintIds = sprintsForEmployee
            .filter((sprint) => {
                const date = parse(sprint.date, 'yyyy-MM-dd 00:00:00', new Date());
                return this.isInRange(fromDate, tillDate, date) || this.isInRange(tillDate, fromDate, date);
            })
            .map((sprint) => sprint.id);

        this.selection.next([...this.selection.value, ...toBeSelectedSprintIds]);
    }

    private isInRange(from: Date, till: Date, date: Date) {
        return isSameWeek(date, from) || (isBefore(from, date) && isAfter(till, date)) || isSameWeek(date, till);
    }
}
